import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function PasswordSetup({ appState, updateState }) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState([]);
  const navigate = useNavigate();

  const validatePassword = (pwd) => {
    const errors = [];
    if (pwd.length < 8) {
      errors.push("Password must be at least 8 characters");
    }
    if (!/[A-Z]/.test(pwd)) {
      errors.push("Password must contain at least one uppercase letter");
    }
    if (!/[a-z]/.test(pwd)) {
      errors.push("Password must contain at least one lowercase letter");
    }
    if (!/[0-9]/.test(pwd)) {
      errors.push("Password must contain at least one number");
    }
    return errors;
  };

  const handlePasswordChange = (value) => {
    setPassword(value);
    setErrors(validatePassword(value));
  };

  const handleNext = () => {
    if (password !== confirmPassword) {
      setErrors(["Passwords don't match"]);
      return;
    }

    const validationErrors = validatePassword(password);
    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      return;
    }

    updateState({ password });
    
    if (appState.isCreatingNew) {
      navigate("/display-recovery-phrase"); // New wallet flow
    } else {
      navigate("/import-options"); // Import wallet flow
    }
  };

  const handleBack = () => {
    navigate("/network-selection");
  };

  const isValid = password.length >= 8 && password === confirmPassword && errors.length === 0;

  return (
    <div className="screen">
      <button className="back-button" onClick={handleBack}>
        ←
      </button>

      <div className="progress-dots">
        <div className="dot completed"></div>
        <div className="dot completed"></div>
        <div className="dot active"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>

      <h1 className="title">Set up a password</h1>
      <p className="subtitle">
        {"It should be at least 8 characters. You'll need this to unlock Backpack."}
      </p>

      <div className="form-group">
        <label className="form-label">Password</label>
        <div className="password-input-container">
          <input
            type={showPassword ? "text" : "password"}
            className="form-input"
            value={password}
            onChange={(e) => handlePasswordChange(e.target.value)}
            placeholder="Enter password"
          />
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "👁️" : "👁️‍🗨️"}
          </button>
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">Confirm Password</label>
        <div className="password-input-container">
          <input
            type={showConfirmPassword ? "text" : "password"}
            className="form-input"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm password"
          />
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? "👁️" : "👁️‍🗨️"}
          </button>
        </div>
      </div>

      {errors.length > 0 && (
        <div className="error-list">
          {errors.map((error, index) => (
            <div key={index} className="error-message">
              {error}
            </div>
          ))}
        </div>
      )}

      <button
        className={`primary-button ${!isValid ? "disabled" : ""}`}
        disabled={!isValid}
        onClick={handleNext}
      >
        Next
      </button>
    </div>
  );
}